import { IBBoxSchema } from '../../../../node/types/bbox';
import { TMapBounds } from '../../../Map/types/mapBounds';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EMapBoundsActionType {
  Changed = 'mapBounds/changed',
  FocusedOnBbox = 'mapBounds/focusedOnBbox',
}

export type TMapBoundsChanged = ITypedReduxAction<EMapBoundsActionType.Changed, TMapBounds>;
export type TMapBoundsFocusedOnBbox = ITypedReduxAction<EMapBoundsActionType.FocusedOnBbox, IBBoxSchema>;

export type TMapBoundsActions = TMapBoundsChanged | TMapBoundsFocusedOnBbox;
